import { mapActions } from 'vuex';

export default (config) => ({
  methods: {
    ...mapActions({
      openNotification: 'openNotification',
      closeNotification: 'closeNotification',
      logError: 'logError',
    }),
    notifyError({
      error,
      data = null,
      notificaction,
      section,
    }) {
      this.logError({
        data,
        errorFrom: `${config.component}:${section}`,
        details: {
          ...Object.getOwnPropertyDescriptors(error),
          message: error.message,
        },
      });
      this.openNotification({
        title: notificaction.title,
        message: `${notificaction.message}`,
        notificationType: 'error',
        showContactInfo: notificaction.showContactInfo || false,
      });
    },
  },
});
